//import SiteConfig from '../assets/Config/SiteConfig';
import React, { useEffect, useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import { Row, Col, Card, Button, Dropdown, Table, Badge, Spinner, Alert } from 'react-bootstrap';
import Layout from '../layout/default';
import {
  Image,
  Icon,
  Media,
  MediaGroup,
  MediaText,
  Pureknob,
  CustomDropdownMenu,
  CustomDropdownToggle,
  OverlineTitle,
  ChartLegend
} from '../components';
import { ChartBar, ChartLine } from "../components/Chart/Charts";
import { Colors } from '../utilities/index';
import hexRGB from '../utilities/hexRGB';

import { AppContext } from '../context/AppContext';
import BirthDaysSection from '../components/Dashboard/BirthDaysSection';
import { useApiClient } from '../ApiService/useApiClient';

const baseURL = ""; 
const apical_url = "HMCareDashboard/";

function HomeEcommerce() {
  const api = useApiClient();
  const [error, setError] = useState(null);
  const [monthdata, setMonthData] = useState({});
  const [weekdata, setWeekData] = useState({});
  const [topclients, setTopClients] = useState([]);
  const [topstaff, setTopStaff] = useState([]);

  const { token, SiteConfig, user } = useContext(AppContext);

  useEffect(() => {
    const fetchMonthStats = async () => {
      try {
        const response = await api.get(baseURL + apical_url + 'monthlystats');
        setMonthData(response.data);
      } catch (err) {
        setError(err);
      }
    };
    fetchMonthStats();

    // console.log("======================");
    // console.log(SiteConfig);
    // console.log("======================");
    // console.log(user);

  }, []);

  useEffect(() => {
    const fetchWeeklyStats = async () => {
      try {
        const response = await api.get(baseURL + apical_url + 'weeklystats');
        setWeekData(response.data);
      } catch (err) {
        setError(err);
      }
    };
    fetchWeeklyStats();
  }, []);

  useEffect(() => {
    const fetchTopClients = async () => {
      try {
        const response = await api.get(baseURL + apical_url + 'topclients');
        setTopClients(response.data);
      } catch (err) {
        setError(err);
      }
    };
    fetchTopClients();
  }, []);

  useEffect(() => {
    const fetchTopStaff = async () => {
      try {
        const response = await api.get(baseURL + apical_url + 'topstaff');
        setTopStaff(response.data);
      } catch (err) {
        setError(err);
      }
    };
    fetchTopStaff();
  }, []);

  if (error) {
    if (error.response?.status === 401) {
      return <Navigate to="/auths/auth-login" />;
    }
    return <Alert variant="danger">Error: {error.message}</Alert>;
  }

  //if (!monthdata.lable || !weekdata.lable) {
  if (!monthdata.lable || !weekdata.lable || !user || !SiteConfig.CURRENT_USER_NAME) {
    return (
      <Layout title="Clients" content="container">
        <Spinner animation="border" variant="primary" />
      </Layout>
    );
  }


  // Prepare chart data structures
  const totalProfitChart1 = {
    labels: monthdata.lable,
    stacked: true,
    ticksValue: '',
    borderDash: [8, 4],
    xGridColor: Colors.white,
    xGridBorderColor: Colors.white,
    yGridBorderColor: Colors.white,
    maxTicksLimit: 20,
    datasets: [
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.primary,
        label: "Total Income",
        borderSkipped: false,
        data: monthdata.revenue
      },
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.success,
        label: "Gross Profit",
        borderSkipped: false,
        data: monthdata.hours
      },
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.gray300,
        label: "Total Expense",
        borderSkipped: false,
        data: monthdata.revenue
      }
    ]
  };

  const totalProfitChartWeek = {
    labels: weekdata.lable,
    legend: true,
    datasets: [
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.primary,
        label: "Total Income",
        borderSkipped: false,
        data: weekdata.revenue
      },
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.yellow,
        label: "Gross Profit",
        borderSkipped: false,
        data: weekdata.hours
      },
      {
        borderRadius: { topLeft: 50, topRight: 50, bottomLeft: 50, bottomRight: 50 },
        backgroundColor: Colors.gray300,
        label: "Total Expense",
        borderSkipped: false,
        data: weekdata.revenue
      }
    ]
  };

  return (
  <>
    <Layout title="HMCarePlanner - Dashboard">
      <Row className="g-gs">      

        {Object.keys(monthdata).length==0 && <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>}            

        {Object.keys(monthdata).length > 0 && 

        <Col xxl="12">
          <Card className="h-100">
              <Row className="g-0 col-sep col-sep-md">
                  <Col md="6">
                      <Card.Body>
                          <div className="card-title-group mb-4">
                              <div className="card-title">
                                  <h4 className="title">Yearly Statistics</h4>
                              </div>
                          </div>
                          <div className="nk-chart-ecommerce-total-profit">
                              <ChartBar data={totalProfitChart1} />
                          </div>
                      </Card.Body>
                  </Col>
                  <Col md="3">
                      <Card.Body>
                          <div className="total-profit-data">
                              <div className="amount-wrap pb-4">
                                  <div className="amount h2 mb-0 fw-bold">£{monthdata.totalrevenue.toLocaleString()}</div>
                                  <span className="smaller">Total Revenue</span>
                              </div>
                              <ul className="nk-data-list-group d-flex flex-column flex-sm-row flex-md-column gap g-4">
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="primary-soft">
                                        <Icon name="coins"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{monthdata.totalrevenue.toLocaleString()}</div>
                                          <span className="smaller">Total Income</span>
                                      </div>
                                  </li>
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="secondary-soft">
                                        <Icon name="coin-alt"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{monthdata.totalexp.toLocaleString()}</div>
                                          <span className="smaller">Total Expense</span>
                                      </div>
                                  </li>
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="success-soft">
                                        <Icon name="trend-up"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{monthdata.grossprofit.toLocaleString()}</div>
                                          <span className="smaller">Gross Profit</span>
                                      </div>
                                  </li>
                                  
                              </ul>
                           
                          </div>
                      </Card.Body>
                  </Col>
                  <Col md="3">
                      <Card.Body>
                          <BirthDaysSection/>
                      </Card.Body>
                  </Col>
              </Row>
          </Card>
        </Col>
      }

      {Object.keys(weekdata).length==0 && <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>}            
      {Object.keys(weekdata).length > 1 && 
        <Col xxl="12">
          <Card className="h-100">
              <Row className="g-0 col-sep col-sep-md">
                  <Col md="8">
                      <Card.Body>
                          <div className="card-title-group mb-4">
                              <div className="card-title">
                                  <h4 className="title">This Week's Statistics</h4>
                              </div>
                          </div>
                          <div className="nk-chart-ecommerce-total-profit">
                              <ChartBar data={totalProfitChartWeek} />
                          </div>
                      </Card.Body>
                  </Col>
                  <Col md="4">
                      <Card.Body>
                          <div className="total-profit-data">
                              <div className="amount-wrap pb-4">
                                  <div className="amount h2 mb-0 fw-bold">£{weekdata.totalrevenue==null?"0":weekdata.totalrevenue.toLocaleString()}</div>
                                  <span className="smaller">Total Revenue</span>
                              </div>
                              <ul className="nk-data-list-group d-flex flex-column flex-sm-row flex-md-column gap g-4">
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="primary-soft">
                                        <Icon name="coins"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{weekdata.totalrevenue.toLocaleString()}</div>
                                          <span className="smaller">Total Income</span>
                                      </div>
                                  </li>
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="secondary-soft">
                                        <Icon name="coin-alt"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{weekdata.totalexp.toLocaleString()}</div>
                                          <span className="smaller">Total Expense</span>
                                      </div>
                                  </li>
                                  <li className="nk-data-list-item">
                                      <Media shape="circle" variant="success-soft">
                                        <Icon name="trend-up"></Icon>
                                      </Media>
                                      <div className="amount-wrap">
                                          <div className="amount h3 mb-0">£{weekdata.grossprofit.toLocaleString()}</div>
                                          <span className="smaller">Gross Profit</span>
                                      </div>
                                  </li>
                                  
                              </ul>
                              {/* <div className="pt-5">
                                  <Button href="#" variant="primary">View Report</Button>
                              </div> */}
                          </div>
                      </Card.Body>
                  </Col>
              </Row>
          </Card>
        </Col>
}
        <Col xxl="6">
          <Card className="h-100">
              <Card.Body className="flex-grow-0 py-2">
                <div className="card-title-group">
                    <div className="card-title">
                        <h4 className="title">Top Clients</h4>
                    </div>
                    <div className="card-tools">
                      <Dropdown>
                          <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                            <Icon name="more-v"></Icon>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                            <Dropdown.Header className="py-2">
                              <h6 className="mb-0">Options</h6>
                            </Dropdown.Header>
                            <Dropdown.Divider className="mt-0" />
                            <Dropdown.Item>Low to high</Dropdown.Item>
                            <Dropdown.Item>High to low</Dropdown.Item>
                          </Dropdown.Menu>
                      </Dropdown>
                    </div>
                </div>
              </Card.Body>
              <Table responsive className="table-middle mb-0">
                  <thead className="table-light table-head-sm">
                      <tr>
                          <th className="tb-col">
                            <OverlineTitle tag="span">Client</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Revenue</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Visits</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Hours</OverlineTitle>
                          </th>
                          {/* <th className="tb-col tb-col-end">
                            <OverlineTitle tag="span">amount</OverlineTitle>
                          </th> */}
                      </tr>
                  </thead>
                  <tbody>

                      {topclients.map(client => (

                         <tr key={client.name}>
                         <td className="tb-col">
                           <MediaGroup>
                               {/* <Media size="md" shape="circle" className="flex-shrink-0">
                                 <Image src="/images/product/a.jpg" alt="product"/>
                               </Media> */}
                               <MediaText>
                                 <span className="title">{client.name}</span>
                                 {/* <span className="text smaller">28 Jul 2022</span> */}
                               </MediaText>
                           </MediaGroup>
                         </td>
                         <td className="tb-col tb-col-end tb-col-sm">
                             <span className="small">£{client.revenue.toLocaleString()}</span>
                         </td>
                         <td className="tb-col tb-col-end tb-col-sm">
                             <span className="small">{client.count}</span>
                         </td>
                         <td className="tb-col tb-col-end tb-col-sm">
                             <span className="small">{client.hours}</span>
                         </td>
                         {/* <td className="tb-col tb-col-end">
                             <span className="small">$14,945</span>
                         </td> */}
                     </tr>

                      ))}

                      
                  </tbody>
              </Table>
          </Card>
        </Col>
        <Col xxl="6">
          <Card className="h-100">
              <Card.Body className="flex-grow-0 py-2">
                <div className="card-title-group">
                    <div className="card-title">
                        <h4 className="title">Top Carers</h4>
                    </div>
                    <div className="card-tools">
                      <Dropdown>
                          <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                            <Icon name="more-v"></Icon>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                            <Dropdown.Header className="py-2">
                              <h6 className="mb-0">Options</h6>
                            </Dropdown.Header>
                            <Dropdown.Divider className="mt-0" />
                            <Dropdown.Item>Low to high</Dropdown.Item>
                            <Dropdown.Item>High to low</Dropdown.Item>
                          </Dropdown.Menu>
                      </Dropdown>
                    </div>
                </div>
              </Card.Body>
              <Table responsive className="table-middle mb-0">
              <thead className="table-light table-head-sm">
                      <tr>
                          <th className="tb-col">
                            <OverlineTitle tag="span">Carer</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Revenue</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Visits</OverlineTitle>
                          </th>
                          <th className="tb-col tb-col-end tb-col-sm">
                            <OverlineTitle tag="span">Total Hours</OverlineTitle>
                          </th>
                          {/* <th className="tb-col tb-col-end">
                            <OverlineTitle tag="span">amount</OverlineTitle>
                          </th> */}
                      </tr>
                  </thead>
                  <tbody>
                  {topstaff.map(client => (

                        <tr key={client.name}>
                          <td className="tb-col">
                            <MediaGroup>                          
                                <MediaText>
                                  <span className="title">{client.name}</span>                          
                                </MediaText>
                            </MediaGroup>
                          </td>
                          <td className="tb-col tb-col-end tb-col-sm">
                              <span className="small">£{client.revenue.toLocaleString()}</span>
                          </td>
                          <td className="tb-col tb-col-end tb-col-sm">
                              <span className="small">{client.count}</span>
                          </td>
                          <td className="tb-col tb-col-end tb-col-sm">
                              <span className="small">{client.hours}</span>
                          </td>                      
                        </tr>

                        ))}
                  </tbody>
              </Table>
          </Card>
        </Col>      
      </Row>
    </Layout>
    
    </>
  )

}

export default HomeEcommerce;
